import { HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type SpinnerProps = HTMLAttributes<HTMLDivElement> & {
  variant?: 'small' | 'medium' | 'large'
}

const Spinner = ({ className, variant = 'medium', ...props }: SpinnerProps) => {
  return (
    <span
      className={cn(
        'block animate-rotate',
        {
          'h-[1.5rem] w-[1.5rem]': variant === 'small',
          'h-[3rem] w-[3rem]': variant === 'medium',
          'h-[10rem] w-[10rem]': variant === 'large'
        },
        className
      )}
      {...props}
    >
      <svg viewBox="25 25 50 50" className="stroke-current">
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth={variant === 'small' ? 5 : variant === 'medium' ? 3 : 0.2}
          strokeMiterlimit="10"
          strokeDasharray="89, 200"
          strokeDashoffset="0"
        />
      </svg>
    </span>
  )
}

export default Spinner
